import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { fmtDate, expiryStatus, STATUS_META } from "@/lib/helpers";
import { Card } from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import { Badge } from "@/components/ui/badge";
import { Skeleton } from "@/components/ui/skeleton";
import { Truck, Search } from "lucide-react";

export default function Vehicles() {
  const [emps, setEmps] = useState(null);
  const [q, setQ] = useState("");

  useEffect(() => {
    api.get("/employees").then((r) => setEmps(r.data)).catch(() => setEmps([]));
  }, []);

  if (!emps) return <Skeleton className="h-64" />;

  const rows = emps.flatMap((e) => (e.vehicles || []).map((v) => ({ ...v, emp: e.name })));
  const filtered = rows.filter(
    (r) => (r.plate || "").toLowerCase().includes(q.toLowerCase()) ||
      (r.emp || "").toLowerCase().includes(q.toLowerCase()) ||
      `${r.brand} ${r.model}`.toLowerCase().includes(q.toLowerCase())
  );

  return (
    <div className="space-y-6">
      <div className="flex flex-col sm:flex-row sm:items-end justify-between gap-4">
        <div>
          <h1 className="font-display text-2xl sm:text-3xl font-extrabold tracking-tight">Flota de Vehículos</h1>
          <p className="text-muted-foreground text-sm mt-1">{rows.length} vehículos asignados. Control de matrícula e ITV.</p>
        </div>
        <div className="relative w-full sm:w-72">
          <Search className="h-4 w-4 absolute left-3 top-1/2 -translate-y-1/2 text-muted-foreground" />
          <Input className="pl-9" placeholder="Buscar matrícula, modelo o empleado" value={q}
            onChange={(e) => setQ(e.target.value)} data-testid="vehicles-search" />
        </div>
      </div>

      {filtered.length === 0 ? (
        <Card className="p-12 text-center text-muted-foreground text-sm">
          <Truck className="h-8 w-8 mx-auto mb-2 opacity-40" /> Sin vehículos registrados.
        </Card>
      ) : (
        <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3" data-testid="vehicles-grid">
          {filtered.map((v) => {
            const st = expiryStatus(v.next_itv);
            const meta = STATUS_META[st];
            return (
              <Card key={v.id} className="p-5 hover:shadow-md transition-shadow">
                <div className="flex items-start justify-between">
                  <div className="h-10 w-10 rounded-lg bg-slate-100 flex items-center justify-center">
                    <Truck className="h-5 w-5 text-slate-700" />
                  </div>
                  <span className="font-mono text-sm font-bold bg-primary text-white px-2.5 py-1 rounded border-2 border-slate-700"
                    data-testid="vehicle-plate">
                    {v.plate}
                  </span>
                </div>
                <p className="font-display font-bold mt-3">{v.brand} {v.model}</p>
                <p className="text-xs text-muted-foreground">{v.vtype} · {v.emp}</p>
                <div className="mt-4 space-y-2 text-sm">
                  <div className="flex justify-between">
                    <span className="text-muted-foreground">Kilometraje</span>
                    <span className="font-mono">{v.mileage ? `${v.mileage} km` : "—"}</span>
                  </div>
                  <div className="flex justify-between items-center">
                    <span className="text-muted-foreground">Próxima ITV</span>
                    <div className="flex items-center gap-2">
                      <span className="font-mono">{fmtDate(v.next_itv)}</span>
                      {v.next_itv && <Badge className={meta.cls}>{meta.label}</Badge>}
                    </div>
                  </div>
                </div>
              </Card>
            );
          })}
        </div>
      )}
    </div>
  );
}
